import { ErrorSharp } from "@material-ui/icons"

const validate = (form: string, values: any) => {
  const errors: any = {}
  if (form === 'login') {
    if (values.email === '') {
      errors.email = 'E-mail is required'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(values.email)) {
      errors.email = 'Email address is invalid'
    }
    if (!values.password) {
      errors.password = 'Password is required'
    } else if (values.password.length < 6) {
      errors.password = 'Password needs to be 6 characters or more.'
    }
  }
  if (form === 'register') {
    // if (!values.firstName) {
    //   errors.firstName = 'First name is required'
    // }
    // if (!values.lastName) {
    //   errors.lastName = 'Last name is required'
    // }
    if (!values.emailAddress) {
      errors.emailAddress = 'E-mail is required'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(values.emailAddress)) {
      errors.emailAddress = 'Email address is invalid'
    }
    if (!values.password) {
      errors.password = 'Password is required'
    } else if (values.password.length < 6) {
      errors.password = 'Password needs to be 6 charachters or more.'
    }
    // if (!values.organisation) {
    //   errors.organisation = 'Organisation is required'
    // }
    // if(values.webAddress && !/^(http?)/i.test(values.webAddress)){
    //   errors.webAddress = 'Web address has to start with http'
    // }
  }
  if (form === 'updateAccount') {
    if (!values.firstName) {
      errors.firstName = 'First name is required'
    }
    if (!values.lastName) {
      errors.lastName = 'Last name is required'
    }
    if (!values.email) {
      errors.email = 'E-mail is required'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(values.email)) {
      errors.email = 'Email address is invalid'
    }
    if (!/^(http?)/i.test(values.webAddress)) {
      errors.webAddress = 'Web address has to start with http'
    }
  }
  if (form === 'addRecipient') {
    if (!values.name) {
      errors.name = 'Recipient name is required'
    }
    if (!values.email) {
      errors.email = 'E-mail is required'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(values.email)) {
      errors.email = 'Email address is invalid'
    }
  }
  if (form === 'resendCertificate') {
    if (!values.resendEmail) {
      errors.resendEmail = 'Required'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(values.resendEmail)) {
      errors.resendEmail = 'Email address is invalid'
    }
  }
  if (form === 'certificateFilters') {
    if (!values.template_code && !values.recipient_name && !values.certificate_name) {
      errors.more_filters_required = 'Please select more filters'
    }
    if (values.template_code && values.template_code.length < 4) {
      errors.template_code = 'Min length of 5 characters'
    }
    if (values.certificate_name && values.certificate_name.length < 4) {
      errors.certificate_name = 'Min length of 5 characters'
    }
    if (values.recipient_name && values.recipient_name.length < 4) {
      errors.recipient_name = 'Min length of 5 characters'
    }
  }

  return errors
}

export default validate
